export const queryListData = `
  id
  deletedAt
  name {
    firstFull
    last
    gender
    title
  }
  identifier
  user {
    role {
      name
      rights
    }
  }
  profilePictureUrl
`;

export const queryGeneralData = `
  id
  nursingHomeId
  deletedAt
  identifier
  name {
    last
    firstFull
    birthName
    title
    gender
  }
  employeeBaseData{
    personalData{
      id
      placeOfBirth
      dateOfBirth
      maritalStatus
      numberOfChildren
      nationality
      confession
    }
    contactData{
      id
      address{
        id
        city
        street
        zipCode
        number
      }
      communication{
        id
        phone
        mobilePhone
        email
      }
    }
    healthInsurance{
      number
      insurance {
        id
        name
      }
    }
    remark
  }
  user {
    id
    role {
      name
      rights
    }
    username
  }
`;

export const querySystemAccessData = `
  id
  role {
    name
    id
  }
  initials
  username
  passwordGenerated
`;

export const queryEmployeeSystemAccessData = `
  id
  deletedAt
  user {
    ${querySystemAccessData}
  }
  timeosUser{
    id
    username
  }
`;

export const queryEmployeeNameAndId = `
  id
  name {
    firstFull
    last
    title
  }
`;
